import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { UserService, StorageService, HelperService, BaseComponent } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { signOut } from "aws-amplify/auth";

@Component({
  selector: "myp-link-fender-account",
  templateUrl: "link-fender-account.component.html",
  standalone: false,
})
export class LinkFenderAccountComponent extends BaseComponent implements OnInit {
  @Output() fenderCognitoAttributesRetrieved: EventEmitter<any> = new EventEmitter();
  @Input() isThirdPartyProvider: boolean = false;
  public email: string;
  public password: string;
  public loading: boolean = false;
  public errorMessage: string = "";
  public passwordVisible: boolean = false;
  public loginMethod: string;
  public success: boolean = false;
  constructor(
    public userService: UserService,
    public storageService: StorageService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public helperService: HelperService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loginMethod = this.user.fender_user_details.provider;
  }

  submit() {
    if (!this.password || !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(this.password)) {
      this.errorMessage =
        "There was an error linking your account. Please make sure your password is at least 8 characters long and contains at least one uppercase letter, one lowercase letter, and one number.";
      return;
    }
    this.loading = true;
    this.userService.linkFenderAccount(this.password).subscribe({
      next: (result: any) => {
        this.userService.getUserDetails(false).subscribe({
          next: (result: any) => {
            this.loading = false;
            this.success = true;
            this.userService.needsToLinkFenderAccount = false;
          },
          error: (error: any) => {
            this.loading = false;
            this.errorMessage =
              "There was an error linking your account. Please make sure your password is at least 8 characters long and contains at least one uppercase letter, one lowercase letter, and one number.";
          },
        });
      },
      error: (error: any) => {
        this.loading = false;
        this.errorMessage =
          "There was an error linking your account. Please make sure your password is at least 8 characters long and contains at least one uppercase letter, one lowercase letter, and one number.";
      },
    });
  }

  async logout() {
    await signOut();
    this.userService.logout().subscribe(() => {
      this.appService.redirectToConnect(false, true);
    });
  }
}
